<template>
  <div class="introducer-list">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-share"></i> Introducer</span>
        <IntroducerForm style="float:right" v-on:submited="getIntroducer()" />
      </div>

      <div class="search-area">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Search Name, Introducer Code"
          v-model="query.search"
          @input="searchEnter()"
        ></el-input>
      </div>

      <data-tables
        v-loading="loading"
        :data="dataTable"
        border
        :page-size="20"
        :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }"
      >
        <el-table-column
          prop="customer_code"
          label="Introducer Code"
          header-align="center"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="Customer Name"
          header-align="center"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="active_bankaccount"
          label="Active Bankaccount"
          header-align="center"
          align="center"
          width="150"
        >
        </el-table-column>

        <el-table-column
          prop="customer_status"
          label="Customer Status"
          header-align="center"
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="introducer_status"
          label="Introducer Status"
          header-align="center"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              effect="dark"
              :type="scope.row.introducer_status === 'ON' ? 'success' : 'info'"
              >{{ scope.row.introducer_status }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="number_of_customer"
          label="Customer"
          header-align="center"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="totalgbp"
          label="Total GBP"
          header-align="center"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="totaleur"
          label="Total EUR"
          header-align="center"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="available_point"
          label="Point"
          header-align="center"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          label="Available Point"
          header-align="center"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.available_point + scope.row.spend_point }}
          </template>
        </el-table-column>

        <el-table-column
          prop="enduser_id"
          label="Action"
          header-align="center"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="
                editIntroducer(
                  scope.row.enduser_id,
                  scope.row.introducer_status
                )
              "
              >Edit</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="downlineManager(scope.row.enduser_id)"
              >Downline</el-button
            >
          </template>
        </el-table-column>
      </data-tables>
    </el-card>
    <IntroducerEditForm
      ref="IntroducerEditForm"
      v-on:submited="getIntroducer()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getIntroducer } from "@/api/introducer";
import IntroducerForm from "./introducer-form";
import IntroducerEditForm from "./introducer-edit-form";
export default {
  components: {
    IntroducerForm,
    IntroducerEditForm,
  },
  computed: {
    ...mapGetters(["user_project"]),
  },
  data() {
    return {
      loading: false,
      dateSearch: "",
      dataTable: [],
      searchTimeout: null,
      query: {
        search: "",
      },
    };
  },
  methods: {
    getIntroducer() {
      this.loading = true;
      getIntroducer(this.query).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.dataTable = data;
        }
      });
    },
    searchEnter() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getIntroducer();
      }, 800);
    },
    downlineManager(enduser_id) {
      window.open(
        `/customer/view/${
          this.user_project
        }/${enduser_id}?tab=introducer&subtab=bonussummary`
      );
    },
    editIntroducer(enduser_id, status) {
      this.$refs.IntroducerEditForm.openDialog(enduser_id, status);
    },
  },
  created() {
    this.getIntroducer();
  },
};
</script>

<style lang="scss">
.introducer-list {
  .search-area {
    margin-bottom: 10px;
  }
}
</style>
